import React, { useContext, useState } from 'react'
import { Redirect, Route, Switch, useLocation, NavLink } from 'react-router-dom'
import { Button, Icon } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'

import UsersPage from './UsersPage'
import SettingsPage from './SettingsPage'
import DeparturesPage from './DeparturesPage'
import ResiduePage from './ResiduePage'
import QueuePage from './QueuePage'
import DriversPage from './DriversPage'
import RequestPage from './RequestPage'
import BidPage from './BidPage'
import CarPage from './CarPage'
import ApplicationsPage from './ApplicationsPage'

import { UserContext } from 'context'
import Page404 from './Page404'

import pageList from 'constants/rolePages.json'
import './MainPage.css'
import ApplicationsTabMenu from 'components/ApplicationsTabMenu'
import { initialStateTabs } from './ApplicationsPage/ApplicationsPage'
import RoutePage from './RoutePage'
import ViolationsPage from './ViolationsPage/ViolationsPage'

function MainPage(props) {
  const [hideMenu, setHideMenu] = useState(true)
  const [crashState, setCrashState] = useState({})

  const { intl } = props
  const { currentUser } = useContext(UserContext)

  const location = useLocation().pathname
  const tabs = pageList[currentUser?.role]

  const [tabState, setTabState] = useState({ ...initialStateTabs })

  const getPageName = () => {
    let name = tabs.find((element) => location === element.url)?.name || 'page404'

    return name
  }

  // Переходимо на першу вкладку із переліку вкладок
  if (props.location.pathname === '/')
    return (<Redirect push to={tabs[0].url} />)

  return (
    <div className="mainPage">
      <div className={"sidebar" + (hideMenu ? ' hide' : '')} onClick={() => setHideMenu(true)}>
        <div className="tabs">
          {tabs.map(tab =>
            <NavLink
              exact
              key={tab.url}
              to={tab.url}
              className='btn'
              activeClassName='active'
            >
              {intl.formatMessage({ id: tab.name })}
            </NavLink>
          )}
        </div>
      </div>
      <div className="content">
        <div className="mainPage__header">
          <div><h1>{intl.formatMessage({ id: getPageName() })}</h1></div>
          {tabState.tab === 3 && <h3>{tabState.calendarDayTitle}</h3>}
          {tabState.tab !== 0 && (
            <ApplicationsTabMenu menuList={tabState.menuList} />
          )}
        </div>
        <hr />
        <Switch>
          <Route exact path="/users" component={UsersPage} />
          <Route exact path="/settings" component={SettingsPage} />
          <Route exact path="/departures" render={()=><DeparturesPage setCrashState={setCrashState} />} />
          <Route exact path="/residues" component={ResiduePage} />
          <Route exact path="/queue" component={QueuePage} />
          <Route exact path="/drivers" component={DriversPage} />
          <Route exact path="/request" component={RequestPage} />
          <Route exact path="/bid" component={BidPage} />
          <Route exact path="/applications" render={() => <ApplicationsPage tabState={tabState} setTabState={setTabState}/>} />
          <Route exact path="/cars" component={CarPage} />
          <Route exact path="/route" component={RoutePage} />
          <Route exact path="/violations" render={()=><ViolationsPage crashState={crashState} setCrashState={setCrashState} />} />
          <Route component={Page404} />
        </Switch>
      </div>
      <Button className={"toggleMenu" + (hideMenu ? ' hide' : '')} onClick={() => setHideMenu(!hideMenu)} icon>
        <Icon name="bars" />
        Menu
      </Button>
    </div>
  )
}

export default injectIntl(MainPage)
